import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "For all eGeeTouch® series of locks, there are several options as follow:",
    reply2: "1) Use eGeeTouch NFC tag provided",
    reply3:
      "2) Bluetooth-enabled mobile devices e.g. e.g. Smartphone, tablet, smartwatch, sportband etc.",
    reply4:
      "3) NFC-enabled mobile devices e.g. Smartphone, tablet, smartwatch, sportband etc.",
    reply5:
      "4) Connect eGeeTouch with mobile devices via USB OTG (USB On-The-Go)",
    reply6:
      "For eGeeTouch® Smart Luggage Lock & Smart travel padlock, a TSA accepted key lock is also built-in for access by TSA authorized personnel in U.S. airports.",
    back: "Back",
  },
  ja: {
    reply1:
      "すべての eGeeTouch® シリーズのロックには、次のようないくつかのオプションがあります。",
    reply2: "1) 付属の eGeeTouch NFC タグを使用します",
    reply3:
      "2) Bluetooth 対応のモバイル デバイス (例:例えばスマートフォン、タブレット、スマートウォッチ、スポーツバンドなど",
    reply4:
      "3) NFC 対応モバイルデバイス (例:スマートフォン、タブレット、スマートウォッチ、スポーツバンドなど",
    reply5:
      "4) USB OTG (USB On-The-Go) 経由で eGeeTouch をモバイルデバイスに接続します",
    reply6:
      "eGeeTouch® スマート ラゲッジ ロックおよびスマート トラベル パドロックには、TSA 認定キー ロックも組み込まれており、米国の空港で TSA 認定職員によるアクセスが可能です。",
    back: "戻る",
  },
  es: {
    reply1:
      "Para todas las series de candados eGeeTouch®, existen varias opciones como las siguientes:",
    reply2: "1) Utilice la etiqueta NFC eGeeTouch proporcionada",
    reply3:
      "2) Dispositivos móviles con Bluetooth, p. p.ej. Smartphone, tableta, reloj inteligente, pulsera deportiva, etc.",
    reply4:
      "3) Dispositivos móviles habilitados para NFC, p. Smartphone, tableta, reloj inteligente, pulsera deportiva, etc.",
    reply5:
      "4) Conecte eGeeTouch con dispositivos móviles a través de USB OTG (USB On-The-Go)",
    reply6:
      "Para el candado inteligente para equipaje y el candado de viaje inteligente eGeeTouch®, también se incorpora un candado con llave aceptado por la TSA para el acceso del personal autorizado por la TSA en los aeropuertos de US.",
    back: "Atrás",
  },
});

class Q17_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <br />
        <br />
        {localizationStrings.reply2}
        <br />
        <br />
        {localizationStrings.reply3}
        <br />
        <br />
        {localizationStrings.reply4}
        <br />
        <br />
        {localizationStrings.reply5}
        <br />
        <br />
        {/* <div>
          <img src="" />
          <br />
        </div> */}
        {localizationStrings.reply6}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q17_component;
